import { render } from "./PascalChove.vue?vue&type=template&id=41e100a2&scoped=true"
import script from "./PascalChove.vue?vue&type=script&lang=js"
export * from "./PascalChove.vue?vue&type=script&lang=js"

import "./PascalChove.vue?vue&type=style&index=0&id=41e100a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e100a2"]])

export default __exports__